<template>
  <header class="site-header">
    <div class="container header-inner">
      <Logo />
      <NavMenu />
      <div class="right-controls">
        <LangSwitcher />
        <el-button type="primary" size="small" @click="$router.push('/contact')">{{ $t('home.cta_contact') }}</el-button>
        <MobileDrawer />
      </div>
    </div>
  </header>
</template>

<script>
import Logo from './Logo.vue'
import NavMenu from './NavMenu.vue'
import LangSwitcher from './LangSwitcher.vue'
import MobileDrawer from './MobileDrawer.vue'

export default {
  name: 'SiteHeader',
  components: { Logo, NavMenu, LangSwitcher, MobileDrawer }
}
</script>

<style scoped>
.site-header { background:#fff; border-bottom:1px solid #eef3f2; position:sticky; top:0; z-index:20 }
.header-inner { display:flex; align-items:center; justify-content:space-between; padding:12px 24px }
.right-controls { display:flex; gap:8px; align-items:center }
@media (max-width:720px) {
  .header-inner { padding:10px }
}
</style>
